import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { CheckCircle, Loader2, XCircle } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CheckoutSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // loading, success, failed
  const [paymentData, setPaymentData] = useState(null);

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    if (sessionId) {
      pollPaymentStatus(sessionId);
    } else {
      setStatus('failed');
    }
  }, [searchParams]);

  const pollPaymentStatus = async (sessionId, attempts = 0) => {
    const maxAttempts = 5;
    const pollInterval = 2000;

    if (attempts >= maxAttempts) {
      setStatus('failed');
      return;
    }

    try {
      const response = await axios.get(`${API}/checkout/status/${sessionId}`);
      const data = response.data;

      if (data.payment_status === 'paid') {
        setStatus('success');
        setPaymentData(data);
        return;
      } else if (data.status === 'expired') {
        setStatus('failed');
        return;
      }

      // Continue polling
      setTimeout(() => pollPaymentStatus(sessionId, attempts + 1), pollInterval);
    } catch (error) {
      console.error('Status check error:', error);
      setTimeout(() => pollPaymentStatus(sessionId, attempts + 1), pollInterval);
    }
  };

  return (
    <div className="page checkout-success-page">
      <Header onEnrollClick={() => {}} />
      
      <main className="page-content">
        <section className="checkout-result">
          <div className="container">
            <div className="result-card">
              {status === 'loading' && (
                <>
                  <Loader2 className="result-icon loading" />
                  <h1>Processing Your Payment</h1>
                  <p>Please wait while we confirm your payment...</p>
                </>
              )}

              {status === 'success' && (
                <>
                  <CheckCircle className="result-icon success" />
                  <h1>Payment Successful!</h1>
                  <p>Welcome to WSafe AI ML. Your journey to mastering AI begins now!</p>
                  
                  <div className="success-details">
                    <h3>What's Next?</h3>
                    <ul>
                      <li>Check your email for login credentials</li>
                      <li>Access your course dashboard</li>
                      <li>Start with Module 1: Foundations of AI</li>
                      <li>Join our community forum</li>
                    </ul>
                  </div>

                  <div className="success-actions">
                    <Link to="/">
                      <Button className="btn-primary">Go to Dashboard</Button>
                    </Link>
                    <Link to="/syllabus">
                      <Button className="btn-secondary">View Syllabus</Button>
                    </Link>
                  </div>
                </>
              )}

              {status === 'failed' && (
                <>
                  <XCircle className="result-icon failed" />
                  <h1>Payment Issue</h1>
                  <p>There was an issue processing your payment. Please try again or contact support.</p>
                  <div className="failed-actions">
                    <Link to="/pricing">
                      <Button className="btn-primary">Try Again</Button>
                    </Link>
                    <Link to="/contact">
                      <Button className="btn-secondary">Contact Support</Button>
                    </Link>
                  </div>
                </>
              )}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default CheckoutSuccessPage;
